{
  "dismissButton": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-issueview-status.issue-view-resolution-changeboarding-body": [
    {
      "type": 0,
      "value": "To keep key information in one spot, we've moved the status and resolution field to the left"
    }
  ],
  "jira-issueview-status.issue-view-resolution-changeboarding-heading": [
    {
      "type": 0,
      "value": "Status is now on the left"
    }
  ],
  "jira-issueview-status.issue-view-status-changeboarding-body": [
    {
      "type": 0,
      "value": "To keep key information in one spot, we've moved status to the left"
    }
  ],
  "jira-issueview-status.issue-view-status-changeboarding-heading": [
    {
      "type": 0,
      "value": "Status is now on the left"
    }
  ],
  "post-office.jira-issueview-status.main-heading.no-translate": [
    {
      "type": 0,
      "value": "Welcome to Jira Issue View Status"
    }
  ]
}